import { createSearchParams, useLocation, useNavigate } from "react-router-dom";

export default function VehicleModelsEditSidebar({ data, activeTab, setActiveTab }: { data: any; activeTab: number; setActiveTab: React.Dispatch<React.SetStateAction<number>> }) {
  const navigate = useNavigate();
  const location = useLocation();

  function changeActiveTab(tab: any) {
    setActiveTab(data.indexOf(tab));
    navigate({
      pathname: location.pathname,
      search: `?${createSearchParams({ tab: tab.name })}`
    });
  }
  
  return (
    <div className="model-edit_sidebar_container">
      <div className="model-edit_sidebar">
        {data?.map((item: any, index: number) => {
          return (
            <div className={`model-edit_sidebar_item ${activeTab === index && "active"} `} onClick={() => changeActiveTab(item)}>
              {item.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
